module.exports = __webpack_public_path__ + "static/media/hahnemuhle-photo-rag-308.a5d901de.jpg";